import type { Callback, State } from './state';

const DONOTUSE: string = 'DONOTUSE';

type Values = { [key:string]: unknown };

/**
 * A base class for building state hooks
 */
export class Hook {
  static readonly hookName: string = DONOTUSE;

  unsubscribe: () => void;

  constructor(public state: State) {
    if (!(this.constructor as typeof Hook).hookName || (this.constructor as typeof Hook).hookName === DONOTUSE) {
      throw new Error('hook subclass must have their own hookName');
    }
    this.unsubscribe = this.subscribe();
    state.hookMap.set((this.constructor as typeof Hook).hookName, this);
  }

  subscribe() {
    const hookMap = this.hookedProps.map(([key]) => key) as string[];
    return this.state.subscribe(this.fromState.bind(this) as Callback, hookMap);
  }

  get hookedProps() {
    const stateProto = Object.getPrototypeOf(this.state) as typeof State;

    if (!stateProto.propertyMap) { stateProto.initPropertyMap(); }

    return [...stateProto.propertyMap]
      .filter(([, definition]) => definition?.hook?.[(this.constructor as typeof Hook).hookName]);
  }

  /**
   * Returns true if the key is configured for this hook
   * @param key
   * @returns boolean
   */
  isHookedProp(key: string) {
    return this.getDefinition(key)?.hook?.[(this.constructor as typeof Hook).hookName];
  }

  getDefinition(key: string) {
    return this.state.propertyMap.get(key);
  }

  toState(values : Values) {
    Object.entries(values)
      .filter(([key]) => this.isHookedProp(key))
      .forEach(([key, value]) => {
        (this.state as object as { [key: string]: unknown })[key] = value;
      });
  }

  fromState() {
    throw new Error('fromState must be implemented in subclasses');
  }

  reset() {
    throw new Error('reset hook must be implemented in subclasses');
  }
}
